import { render, staticRenderFns } from "./customAlertaModal.vue?vue&type=template&id=885999da&scoped=true&"
import script from "./customAlertaModal.vue?vue&type=script&lang=js&"
export * from "./customAlertaModal.vue?vue&type=script&lang=js&"
import style0 from "./customAlertaModal.vue?vue&type=style&index=0&id=885999da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885999da",
  null
  
)

export default component.exports